<template>
    <div>
        <template v-if="!noUpdate">
            <v-text-field v-model="search" id="field" :disabled="loading" outlined></v-text-field>
            <v-chip v-for="(loc, index) in locations" :key="index" class="ma-2" close
                @click:close="removeLocation(index)">
                {{ loc.city }} - {{ loc.state }} - {{ loc.country }}
            </v-chip>
           
        </template>
        <v-row v-show="locations.length">
            
            <v-col v-if="!noUpdate">
                <div class="text-p" v-if="image">Pre-visualização do mapa</div>

                <v-img v-if="image" width="720" :src="image"></v-img>
            </v-col>

        </v-row>
    </div>
</template>
<script>
// import { MarkerClusterer } from "@googlemaps/markerclusterer"
import { loadedGoogleMapsAPI } from '@/main'
// import * as htmlToImage from 'html-to-image';
import { getStorage, ref, getDownloadURL, uploadString } from "firebase/storage";

// import { toJpeg } from 'html-to-image';
export default {
    data: () => ({
        zoom: 3,
        processing: false,
        changed: false,
        mapInput: null,
        places: [],
        search: "",
        image: "",
        map: null,
        loading: false,
        locations: []
    }),
    props: {
        path: String,
        snapLocations: Array,
        noUpdate: Boolean
    },
    mounted() {
        
        this.locations = this.snapLocations && this.snapLocations.length ? JSON.parse(JSON.stringify(this.snapLocations)) : []
        this.mapInput = new google.maps.places.Autocomplete(document.getElementById("field"), {
            types: []
        });
        this.mapInput.addListener('place_changed', () => {
            this.addPlace(this.mapInput.getPlace());
        })
        let scriptPolyFill = document.createElement('script')
        scriptPolyFill.setAttribute('src', 'https://polyfill.io/v3/polyfill.min.js?features=default')
        document.head.appendChild(scriptPolyFill)

        let googlemaps = document.createElement('script')
        // googlemaps.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBDZQUtQQjIrF2Vus_zv5XRnFBB1-fun50&libraries=places,geometry,visualization&language=pt-BR')
        // googlemaps.setAttribute('defer', 'defer');
        document.head.appendChild(googlemaps)
        //   setTimeout(() => {
        //     this.loadMap()
        //   },100000)
        loadedGoogleMapsAPI.then(() => {
            this.initMap()
            this.loading = false
        });

    },
    watch: {

        places: {
            handler(val) {
                console.log('places', val)
            }
        },
        changed: {
            handler(val) {
                this.$emit('locations-changed', val)
            }
        },
    },


    methods: {

        removeLocation(index) {
            this.locations.splice(index, 1);
            const v = { mapImage: "", locations: this.locations }
            console.log('Vvvv', v)
            this.$emit('locations-changed', v)
            this.$emit('update-locations', v)
            this.initMap()
        },
        addPlace(place) {
            let processedPlace = this.preProcessPlace(place);
            this.locations.push(processedPlace)
            this.search = ""
            this.changed = true;
            const val = { mapImage: "", locations: this.locations}

            this.$emit('locations-changed', val)
            this.$emit('update-locations', val)
            this.initMap()
        },
        preProcessPlace(place) {
            let processedPlace = {};
            console.log('PLACE TO ADD', place)
            if (place.hasOwnProperty('address_components')) {
                let addr_component_types = {
                    route: {
                        targetProperty: 'long_name',
                        newPropertyName: 'street'
                    },
                    sublocality_level_1: {
                        targetProperty: 'long_name',
                        newPropertyName: 'district'
                    },
                    postal_code: {
                        targetProperty: 'long_name',
                        newPropertyName: 'zip_code'
                    },
                    administrative_area_level_1: {
                        targetProperty: 'short_name',
                        newPropertyName: 'state'
                    },
                    administrative_area_level_2: {
                        targetProperty: 'long_name',
                        newPropertyName: 'city'
                    },
                    street_number: {
                        targetProperty: 'long_name',
                        newPropertyName: 'number'
                    },
                    country: {
                        targetProperty: 'long_name',
                        newPropertyName: 'country'
                    }

                };
                place.address_components.forEach(addr_component => {
                    let addr_type = addr_component.types[0];
                    let relationship = addr_component_types[addr_type];
                    if (relationship)
                        processedPlace[relationship.newPropertyName] = addr_component[relationship.targetProperty];
                })
            }
            processedPlace.location = {
                type: "Point",
                coordinates: [place.geometry.location.lng(), place.geometry.location.lat()]
            }
            console.log('Processed', processedPlace)
            return processedPlace;

        },
        saveZoom() {
            if(!this.noUpdate){


            this.processing = true
            this.image = ""
            document.querySelector('.gm-bundled-control').style.display = 'none'
            document.querySelector('.gmnoprint').style.display = 'none'
            document.querySelector('.gm-fullscreen-control').style.display = 'none'
            setTimeout(() => {
                const node = document.getElementById('map');
                htmlToImage.toJpeg(node, { quality: 0.7 }).then((dataUrl) => {
                    console.log('dataURL', dataUrl)
                    const storage = getStorage();
                    const imageUrl = `maps/${this.path}/${moment().format('X')}.jpg`
                    const storageRef = ref(storage, imageUrl)
                    uploadString(storageRef, dataUrl, 'data_url').then(() => {

                        getDownloadURL(storageRef).then((url) => {
                            this.image = url;
                            this.$emit('update-locations', { mapImage: url, locations: this.locations })
                            this.changed = false
                            document.querySelector('.gm-bundled-control').style.display = 'block'
                            document.querySelector('.gmnoprint').style.display = 'block'
                            document.querySelector('.gm-fullscreen-control').style.display = 'block'
                            this.processing = false
                        })
                    })
                })
                    .catch(function (error) {
                        this.processing = false
                        document.querySelector('.gm-bundled-control').style.display = 'block'
                        document.querySelector('.gmnoprint').style.display = 'block'
                        document.querySelector('.gm-fullscreen-control').style.display = 'block'
                        console.error('oops, something went wrong!', error);
                    });
            }, 500)
        }
        else{
            this.processing = false
                        document.querySelector('.gm-bundled-control').style.display = 'block'
                        document.querySelector('.gmnoprint').style.display = 'block'
                        document.querySelector('.gm-fullscreen-control').style.display = 'block'
                        console.error('oops, something went wrong!', error);
        }

        },
        initMap(toSave = false, saveZoom = false) {
            if (toSave) {
                this.processing = true
            }
            const map = new google.maps.Map(document.getElementById("map"), {
                zoom: this.zoom,
                center: { lat: -28.024, lng: 140.887 },
                disableDefaultUI: toSave,
            });
            let zoom = 3
            if (!toSave)
                map.addListener("zoom_changed", () => {
                    // 3 seconds after the center of the map has changed, pan back to the
                    // marker.
                    // if(toSave || saveZoom)
                    zoom = map.getZoom()
                });
            else
                zoom = this.zoom
            const infoWindow = new google.maps.InfoWindow({
                content: "",
                disableAutoPan: true,
            });
            // if(saveZoom)
            this.zoom = zoom

            // Create an array of alphabetical characters used to label the markers.
            // const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            // Add some markers to the map.
            const bounds = new google.maps.LatLngBounds();
            const markers = this.locations.map((loc, i) => {
                const position = { lat: loc.location.coordinates[1], lng: loc.location.coordinates[0] }
                // const label = labels[i % labels.length];
                const marker = new google.maps.Marker({
                    position,
                    // label,
                });

                // markers can only be keyboard focusable when they have click listeners
                // open info window when marker is clicked
                const currentPosition = new google.maps.LatLng(loc.location.coordinates[1], loc.location.coordinates[0]);

                marker.addListener("click", () => {
                    infoWindow.setContent(label);
                    infoWindow.open(map, marker);
                });
                bounds.extend(currentPosition);
                return marker;
            });
            console.log('current zoom', this.zoom)
            if (!toSave || saveZoom)
                map.fitBounds(bounds);
            // Add a marker clusterer to manage the markers.
            // const markerCluster = new MarkerClusterer({ map, markers });
            map.setZoom(this.zoom)
            new markerClusterer.MarkerClusterer({ markers, map });
        }
    }
}
</script>
<style>
#map {
    height: 480px;
    width: 545px;
    display: block;
    background: #f0f0f0;
}
</style>